import type { SiteConfig } from '@c214/shared';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api';

export function useConfig() {
  return useQuery({ queryKey: ['config'], queryFn: () => apiGet<SiteConfig>('/api/config') });
}
